import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { shortenString } from "../../../Constant/helper";
import CustomScrollbars from "../CommonComponents/CustomScrollbars";
import CommonModal from "../CommonComponents/Modal/CommonModal";

const TestChat = ({ chatData, setState }) => {
  const reducer: any = useSelector((state) => state);
  const {
    CustomerReducer: { customersList },
  } = reducer;
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const currentUser = chatData[selectedTabIndex];

  const getPersonName = (customerId) => {
    const customer = customersList?.find((cust) => cust?._id === customerId);
    return customer?.customerName
      ? shortenString(customer?.customerName, 20)
      : "";
  };

  return (
    <CommonModal
      heading={
        <Tabs
          value={selectedTabIndex}
          onChange={(_, newValue) => setSelectedTabIndex(newValue)}
          sx={{
            ...commonStyles.tabs,
            border: "1px solid #AEB6C1",
            boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.12)",
            padding: "4px",
          }}
        >
          {chatData?.map((chat, index) => (
            <Tab
              key={index}
              label={getPersonName(chat?.customer) || `Person ${index + 1}`}
              value={index}
              sx={{ ...commonStyles.tab, borderRadius: "4px" }}
            />
          ))}
        </Tabs>
      }
      body={<ChatBody currentUser={currentUser} />}
      show={chatData?.length > 0}
      toggle={() =>
        setState((prev) => ({
          ...prev,
          chatData: [],
        }))
      }
      handleSave={() => ""}
      footer={false}
      size={900}
    />
  );
};

export default TestChat;

const ChatBody = ({ currentUser }) => {
  return (
    <Box>
      <Typography className="font-16-grey">Customer Profile:</Typography>
      <Typography className="font-14-darkGrey ml-2">
        {currentUser?.customer}
      </Typography>
      <Box sx={{ py: 2 }}>
        <CustomScrollbars height="400px">
          {currentUser?.chat_history?.length > 0
            ? currentUser?.chat_history?.map((message, ind) => {
                const isUser = message.author === "user";
                return (
                  <Box
                    className={isUser ? "flex-end" : "flex-row"}
                    key={ind}
                    sx={{
                      p: 1.5,
                    }}
                  >
                    <Box
                      sx={{
                        px: 2,
                        py: 1,
                        maxWidth: "80%",
                        backgroundColor: isUser ? "#EDF3FF" : "#F3F6FD",
                        borderRadius: isUser
                          ? "15px 0px 15px 15px"
                          : "0px 15px 15px 15px",
                      }}
                    >
                      <Box>
                        <Typography className="font-12-400-lightgrey">
                          {isUser ? "User" : "Bot"}
                        </Typography>
                        <Typography className="font-12-400-lightgrey">
                          {message?.content}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                );
              })
            : "No Chat History Available."}
        </CustomScrollbars>
      </Box>
    </Box>
  );
};
